import { gql } from '@apollo/client';

export const ChangeTrainingGuide = gql`
    mutation changeTrainingGuide($newGuide: String!, $agentId: ID!) {
        changeTrainingGuide(newGuide: $newGuide, agentId: $agentId) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
